<div class="ng-row mt-30 pt-10" justify-content-center>
    <div class="ng-col" col-auto>
      <div class="circle-icon">
        <i class="icon-wallet"></i>
      </div>
    </div>
  </div>